<div class="form-container" id="contextes-form" appearance="outlined" data-tfa="creer_objet-maquette">
    <mat-card-title>
        <h2>Contextes</h2>
    </mat-card-title>
    <mat-card-content>
        @for (contexte of contextes; track contexte) {
        <div class="contexte-container" [class.contexte-actuel]="contexte.id === idContexteActuel()">
            @if (contexte.id === idContexteActuel()) {
            <h2>Contexte actuel</h2>
            }
            <span class="contextePath">
                <mat-chip-set
                    [attr.aria-label]="'chemins du contexte ' + contexte.cheminCodesTemoinValideList?.join('>')"
                    [attr.data-tfa]="'contexte_' + contexte.cheminCodesTemoinValideList?.join('>')"
                    role="list"
                >
                    @for (cheminCodesTemoinValideList of contexte.cheminCodesTemoinValideList; track cheminCodesTemoinValideList; let i =
                    $index) { @if (i !== 0) {
                    <mat-icon data-tfa="icone-fleche" class="icone-fleche" aria-label="parent de" aria-hidden="false">arrow_right</mat-icon>
                    }
                    <mat-chip
                        [ngClass]="cheminCodesTemoinValideList.contexteValide ? 'cheminValide' : 'cheminNonValide'"
                        [routerLink]="'../' + contexte?.chemin![i]"
                        [attr.data-tfa]="'étiquette-code ' + cheminCodesTemoinValideList.codeObjetMaquette"
                        class="chemin-element"
                        role="listitem"
                        tabIndex="0"
                    >
                        {{ cheminCodesTemoinValideList.codeObjetMaquette }}
                        @if (cheminCodesTemoinValideList.contexteValide) {
                        <mat-icon data-tfa="icone-contexte-valide" class="cheminValide">done</mat-icon>
                        } @if (!cheminCodesTemoinValideList.contexteValide) {
                        <mat-icon data-tfa="icone-contexte-non-valide" class="cheminNonValide">clear</mat-icon>
                        }
                    </mat-chip>
                    }
                </mat-chip-set>
                @if (this.currentValidationStateMap.get(contexte.id!)) {
                <button
                    data-tfa="button_validation_chemin"
                    class="mat-icon-button-toggle"
                    aria-label="'L\'objet est validé dans ce contexte'"
                    mat-icon-button
                    [matTooltip]="'L\'objet est validé dans ce contexte'"
                >
                    <mat-icon
                        data-tfa="icon_validation_chemin"
                        aria-hidden="true"
                        [ngClass]="{ 'mat-button-toggle-checked': this.currentValidationStateMap.get(contexte.id!) }"
                        >done</mat-icon
                    >
                </button>
                } @if (this.currentPIAStateMap.get(contexte.id!); as pia) {
                <button
                    data-tfa="button_pia_chemin"
                    class="mat-icon-button-toggle"
                    mat-icon-button
                    [matTooltip]="'L\'objet est un point d\'inscription administrative dans ce contexte'"
                >
                    @if (pia.actif) {
                    <mat-icon
                        data-tfa="icon_pia_chemin"
                        [ngClass]="{ 'mat-button-toggle-checked': !!this.currentPIAStateMap.get(contexte.id!) }"
                        >person_pin</mat-icon
                    >
                    } @else {
                    <mat-icon data-tfa="icon_pia_chemin_inactif">group_off</mat-icon>
                    }
                    <ng-template #piaInactif>
                        <mat-icon data-tfa="icon_pia_chemin_inactif">group_off</mat-icon>
                    </ng-template>
                </button>
                }
            </span>
            @if ( isOpenedValeurParDefaultAlert && !objetMaquetteSelected.mutualise && (etcsParDefautValue || natureDefautValue ||
            plageDeChoixDefaultValue) ) {
            <lib-pegase-message-contextuel
                data-tfa="valeur-par-defaut-alert"
                class="valeur-par-defaut-alert"
                [type]="'info'"
                (closed)="isOpenedValeurParDefaultAlert = false"
            >
                <div class="valeur-par-defaut-message">
                    <div>
                        Il n'est pas nécessaire de renseigner une valeur contextuelle pour un objet non mutualisé: les valeurs intrinsèques
                        sont automatiquement reportées sur son contexte unique.
                    </div>
                    <div>
                        Si vous renseignez tout de même une valeur contextuelle différente, celle ci sera enregistrée. Les 2 valeurs,
                        intrinsèque et contextuelle seront utiles si l'objet devient mutualisé
                    </div>
                </div>
            </lib-pegase-message-contextuel>
            } @if (formMap.get(contexte.id!)) {
            <div [formGroup]="formMap.get(contexte.id!)!" class="form-field-group">
                @if (!isGroupement) {
                <mat-form-field
                    class="form-field"
                    [matTooltip]="
                        !!etcsParDefautValue
                            ? 'La valeur intrinsèque des ECTS de l\'objet déjà renseignée dans &quot;descripteurs&quot; est ' +
                              etcsParDefautValue
                            : ''
                    "
                >
                    <mat-label>ECTS @if (etcsParDefautValue) { (Défaut: {{ etcsParDefautValue }}) } </mat-label>
                    <input
                        [attr.data-tfa]="'input_ects_descripteurs_contexte_' + contexte.cheminCodesTemoinValideList?.join('>')"
                        matInput
                        formControlName="ects"
                        placeholder="ECTS"
                    />
                    <mat-error *appFormMatErrors="formMap.get(contexte.id!)!.controls.ects"></mat-error>
                </mat-form-field>
                }
                <!-- Champ "nature" -->
                <app-select-nomenclature
                    class="form-field select-nature"
                    [formControl]="formMap.get(contexte.id!)?.controls?.nature!"
                    name="nature"
                    [matTooltip]="
                        !!natureDefautValue
                            ? 'La valeur intrinsèque de la nature de l\'objet déjà renseignée dans &quot;descripteurs&quot; est ' +
                              natureDefautValue
                            : ''
                    "
                    [label]="natureDefautValue ? '(Défaut: ' + natureDefautValue + ')' : 'Nature'"
                    [nomenclature]="isGroupement ? NomenclatureType.NatureGroupement : NomenclatureType.NatureTypeObjetFormation"
                    [contexteConsommation]="espace()"
                    [isParametrage]="true"
                    [attr.data-tfa]="'input_ects_descripteurs_nature_' + contexte.cheminCodesTemoinValideList?.join('>')"
                    [dataTfaIdentifier]="contexte.cheminCodesTemoinValideList?.join('>')"
                ></app-select-nomenclature>
                @if (isGroupement) {
                <div class="plage-dechoix-container">
                    <div class="form-field center-toggle">
                        @if (plageDeChoixFormMap.get(contexte.id!)) {
                        <mat-slide-toggle
                            [attr.id]="'plage-de-choix-toggle_' + contexte.id"
                            [attr.data-tfa]="'plage-de-choix-toggle_' + contexte.cheminCodesTemoinValideList?.join('>')"
                            [formControl]="plageDeChoixFormMap.get(contexte.id!)!.controls.plageDeChoix"
                            [checked]="plageDeChoixFormMap.get(contexte.id!)!.controls.plageDeChoix.value"
                            >Plage de choix</mat-slide-toggle
                        >
                        } @if (plageDeChoixFormMap.get(contexte.id!)!.hasError('plageDeChoixMinMax')) {
                        <mat-error>La valeur min doit être inférieure à la valeur max</mat-error>
                        } @if (plageDeChoixFormMap.get(contexte.id!)!.hasError('plageDeChoixDeuxValeurs')) {
                        <mat-error>La valeur min ET la valeur max doivent être renseignées</mat-error>
                        } @if (plageDeChoixDefaultValue) {
                        <mat-hint>Valeur par défaut: {{ !!plageDeChoixDefaultValue ? 'oui' : 'non' }}</mat-hint>
                        }
                    </div>
                    @if ( plageDeChoixFormMap.get(contexte.id!) && plageDeChoixFormMap.get(contexte.id!)!.controls.plageDeChoix.value ===
                    true ) {
                    <mat-form-field
                        class="form-field plage-de-choix-input"
                        subscriptSizing="dynamic"
                        [matTooltip]="
                            !!plageDeChoixDefaultValue
                                ? 'La valeur de plage de choix Min de l\'objet déjà renseignée dans &quot;descripteurs&quot; est ' +
                                  plageDeChoixDefaultValue.min
                                : ''
                        "
                    >
                        <mat-label
                            >Minimum {{ plageDeChoixDefaultValue ? '(Défaut: ' + plageDeChoixDefaultValue.min + ')' : '' }}</mat-label
                        >
                        <input
                            matInput
                            #minInput
                            [attr.data-tfa]="'input_plage-de-choix_min_' + contexte.cheminCodesTemoinValideList?.join('>')"
                            [formControl]="plageDeChoixFormMap.get(contexte.id!)!.controls.min"
                            type="text"
                            inputmode="numeric"
                        />
                        <mat-error *appFormMatErrors="plageDeChoixFormMap.get(contexte.id!)!.controls.min"></mat-error>
                    </mat-form-field>
                    @if (plageDeChoixFormMap.get(contexte.id!)) {
                    <mat-form-field
                        class="form-field plage-de-choix-input"
                        subscriptSizing="dynamic"
                        [matTooltip]="
                            !!plageDeChoixDefaultValue
                                ? 'La valeur de plage de choix Max de l\'objet déjà renseignée dans &quot;descripteurs&quot; est ' +
                                  plageDeChoixDefaultValue.max
                                : ''
                        "
                    >
                        <mat-label
                            >Maximum {{ plageDeChoixDefaultValue ? '(Défaut: ' + plageDeChoixDefaultValue.max + ')' : '' }}</mat-label
                        >
                        <input
                            matInput
                            #maxInput
                            [attr.data-tfa]="'input_plage-de-choix_max_' + contexte.cheminCodesTemoinValideList?.join('>')"
                            [formControl]="plageDeChoixFormMap.get(contexte.id!)!.controls.max"
                            type="text"
                            inputmode="numeric"
                        />
                        <mat-error *appFormMatErrors="plageDeChoixFormMap.get(contexte.id!)!.controls.max"></mat-error>
                    </mat-form-field>
                    } }
                </div>
                } @if ( !isOpenedValeurParDefaultAlert && !objetMaquetteSelected.mutualise && (etcsParDefautValue || natureDefautValue ||
                plageDeChoixDefaultValue) ) {
                <button mat-icon-button color="accent" data-tfa="icon-info-button" (click)="isOpenedValeurParDefaultAlert = true">
                    <mat-icon data-tfa="icon-info">info</mat-icon>
                </button>
                }
            </div>
            } @if (formMap.get(contexte.id!)) {
            <div class="buttons-horizontal-container">
                <ng-content select="#bouton-fermer-objet-maquette"></ng-content>
                @if (formMap.get(contexte.id!)?.enabled) {
                <button
                    [attr.data-tfa]="'enregistrer-button_' + contexte.cheminCodesTemoinValideList?.join('>')"
                    mat-raised-button
                    color="primary"
                    (click)="modifierDescripteursContexteHandler(contexte)"
                    [disabled]="!canSaveContext(contexte.id!)"
                >
                    <mat-icon data-tfa="icone-valider">check</mat-icon>
                    Enregistrer
                </button>
                }
            </div>
            }
        </div>
        }
    </mat-card-content>
</div>

<ng-template #modifierDescripteursContexteValideDialogTmpl>
    <p>
        Vous allez modifier des descripteurs contextuels @switch (typeObjetMaquette()) { @case (TypesObjetMaquette.Formation) {
        <span> d'une formation déjà validée</span>
        } @case (TypesObjetMaquette.ObjetFormation) {
        <span> d'un objet de formation déjà validé</span>
        } @case (TypesObjetMaquette.Groupement) {
        <span> d'un groupement déjà validé</span>
        } } . Si vous confirmez, ces modifications seront propagées dans les autres modules de Pégase.
    </p>
    <p class="modifierDescripteursContexteValideDialogTmpl-emphasized">
        Avant de confirmer il est de votre responsabilité de vérifier toutes les conséquences de cette action.
    </p>
    @switch (typeObjetMaquette()) { @case (TypesObjetMaquette.Groupement) {
    <span>
        <ul>
            <li>
                en cas d'élargissement/rétrécissement de la plage de choix, en cas de modification du type de groupement, pensez à vérifier
                les impacts sur les CHC (incomplets ou en sur nombre)
            </li>
            <li>etc</li>
        </ul>
    </span>
    } @default {
    <span>
        <ul>
            <li>
                en cas de modifications d' ECTS, pensez à vérifier les impacts sur les délibérations déjà réalisées et les relevés de notes
                déjà édités
            </li>
            <li>etc</li>
        </ul>
    </span>
    } }
</ng-template>
